import { type ReactNode, useEffect } from 'react';

import { noop } from '../../type';

interface SyncMessageProps {
  message: ReactNode;
  children?: any;
  onHide: () => void;
  duration?: number;
  showMessage?: boolean;
}

const SyncMessage = ({
  message,
  children,
  duration = 3000,
  showMessage = false,
  onHide,
}: SyncMessageProps) => {
  useEffect(() => {
    if (!showMessage) {
      return noop;
    }

    const timer = setTimeout(() => {
      onHide();
    }, duration);
    return () => clearTimeout(timer);
  });

  if (showMessage) {
    return message;
  }

  return children;
};

export default SyncMessage;
